import { useState, useRef, useEffect } from "react";
import StatsTabsNav from "../../../components/stats/StatsTabsNav";
import GoalsTab from "../../../components/stats/GoalsTab";
import AssistsTab from "../../../components/stats/AssistsTab";
import YellowCardsTab from "../../../components/stats/YellowCardsTab";
import RedCardsTab from "../../../components/stats/RedCardsTab";
import { ChevronLeft, ChevronRight } from "lucide-react";

const StatsTab = ({ tournament, selectedSubcategory }) => {
  const [activeTab, setActiveTab] = useState("goals");
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const tabsContainerRef = useRef(null);

  // Efecto para comprobar la visibilidad de las flechas de scroll
  useEffect(() => {
    const checkScroll = () => {
      if (tabsContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } =
          tabsContainerRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
      }
    };

    // Comprobar al montar y al redimensionar
    checkScroll();
    window.addEventListener("resize", checkScroll);

    // Comprobar periódicamente por si el contenido cambia
    const interval = setInterval(checkScroll, 500);

    return () => {
      window.removeEventListener("resize", checkScroll);
      clearInterval(interval);
    };
  }, [activeTab]);

  // Función para hacer scroll horizontal
  const scrollTabs = (direction) => {
    if (tabsContainerRef.current) {
      const scrollAmount = 150;
      tabsContainerRef.current.scrollBy({
        left: direction === "right" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      {/* Tabs con scroll horizontal */}
      <div className="relative mb-4">
        {/* Flecha izquierda */}
        {showLeftArrow && (
          <button
            onClick={() => scrollTabs("left")}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-1 shadow-md hover:bg-gray-100 transition"
            style={{ top: "50%" }}
          >
            <ChevronLeft size={20} className="text-gray-600" />
          </button>
        )}

        {/* Flecha derecha */}
        {showRightArrow && (
          <button
            onClick={() => scrollTabs("right")}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-1 shadow-md hover:bg-gray-100 transition"
            style={{ top: "50%" }}
          >
            <ChevronRight size={20} className="text-gray-600" />
          </button>
        )}

        {/* Contenedor de tabs con scroll */}
        <div
          ref={tabsContainerRef}
          className="flex overflow-x-auto scrollbar-hide rounded-lg p-1 scroll-smooth"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          <StatsTabsNav activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>

      <div className="min-h-[200px]">
        {activeTab === "goals" && (
          <GoalsTab
            tournament={tournament}
            selectedSubcategory={selectedSubcategory}
          />
        )}
        {activeTab === "assists" && (
          <AssistsTab
            tournament={tournament}
            selectedSubcategory={selectedSubcategory}
          />
        )}
        {activeTab === "yellow" && (
          <YellowCardsTab
            tournament={tournament}
            selectedSubcategory={selectedSubcategory}
          />
        )}
        {activeTab === "red" && (
          <RedCardsTab
            tournament={tournament}
            selectedSubcategory={selectedSubcategory}
          />
        )}
      </div>
    </div>
  );
};

export default StatsTab;
